import { render, staticRenderFns } from "./sendWater.vue?vue&type=template&id=41bd263e&scoped=true&"
import script from "./sendWater.vue?vue&type=script&lang=js&"
export * from "./sendWater.vue?vue&type=script&lang=js&"
import style0 from "./sendWater.vue?vue&type=style&index=0&id=41bd263e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bd263e",
  null
  
)

export default component.exports